export default "__VITE_ASSET__BLfEcbkZ__"